import { BACKEND } from "../variables.js";
import axios from "axios";

const LIST_BY_HOUSE = BACKEND + "/parkingInvoices/listByHouse";
const LIST_BY_VEHICLE = BACKEND + "/parkingInvoices/listByVehicle";
const MARK_PAID = BACKEND + "/parkingInvoices/markPaid";
const CANCEL = BACKEND + "/parkingInvoices/cancel";
const DELETE = BACKEND + "/parkingInvoices/delete";

export default {
  actions: {
    ["GET_PARKING_INVOICES_BY_HOUSE"](state, payload) {
      return axios({
        method: "POST",
        url: LIST_BY_HOUSE,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["GET_PARKING_INVOICES_BY_VEHICLE"](state, payload) {
      return axios({
        method: "POST",
        url: LIST_BY_VEHICLE,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["MARK_PARKING_INVOICE_PAID"](state, payload) {
      return axios({
        method: "POST",
        url: MARK_PAID,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["CANCEL_PARKING_INVOICE"](state, payload) {
      return axios({
        method: "POST",
        url: CANCEL,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    ["DELETE_PARKING_INVOICE"](state, payload) {
      return axios({
        method: "POST",
        url: DELETE,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
  },
};
